var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRightBig(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Fill=false"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.12 11.2571L12.864 2.97708C12.72 2.83308 12.648 2.65708 12.648 2.44908C12.648 2.24108 12.72 2.06508 12.864 1.92108C13.008 1.77708 13.184 1.70508 13.392 1.70508C13.6 1.70508 13.776 1.77708 13.92 1.92108L24 12.0011L13.92 22.0811C13.776 22.2251 13.6 22.2971 13.392 22.2971C13.184 22.2971 13.008 22.2251 12.864 22.0811C12.72 21.9371 12.648 21.7611 12.648 21.5531C12.648 21.3451 12.72 21.1691 12.864 21.0251L21.12 12.7451H0.744C0.536 12.7451 0.36 12.6731 0.216 12.5291C0.072 12.3851 0 12.2091 0 12.0011C0 11.7931 0.072 11.6171 0.216 11.4731C0.36 11.3291 0.536 11.2571 0.744 11.2571H21.12Z",
    fill: "content"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightBig);
export default __webpack_public_path__ + "static/media/arrow-right-big.f72ebe2b60c7557d78e2ccfe2b351c78.svg";
export { ForwardRef as ReactComponent };